<template>
  <div>
    <b-row v-if="!client && !is_iframed" class="my-3 d-lg-none">
      <b-col class="col-12 col-md-10 col-lg-8">
        <b-card>
          <h5 class="text-branded">
            <i class="fa fa-fw fa-plus-square"></i>
            {{ trans('add_to_home_screen') }}
          </h5>
          <p v-html="trans('add_to_home_screen_about')">
            {{ trans('template_edit_branding') }}
          </p>
        </b-card>
      </b-col>
    </b-row>
    <connect v-if="!client" :organization="organization"></connect>
    <b-form-select v-model="selectedLink" :options="links" class="mobile-navigation-select" style="display: none" @input="mobileNavChange"></b-form-select>
    <b-tabs v-if="!!client" v-model="tab" pills class="branded mb-4" content-class="mt-3 mb-4" nav-class="nav-pills" nav-wrapper-class="nav-pills-body">
      <b-tab
        :title="trans('information')"
        title-link-class="text-branded"
        lazy
      >
        <information :organization="organization" :client="client" @jdm="onJdm"></information>
      </b-tab>
      <b-tab
        v-if="showClassesTab"
        :title="trans('classes_events')"
        title-link-class="text-branded"
        lazy
      >
        <classes :organization="organization" :client="client"></classes>
      </b-tab>
      <b-tab
        v-if="showTeamsTab"
        :title="trans('teams')"
        title-link-class="text-branded"
        lazy
      >
        <teams :organization="organization" :client="client"></teams>
      </b-tab>
      <b-tab
        v-if="showStudentsWithSkillsTab"
        :title="trans('skills')"
        title-link-class="text-branded"
        lazy
      >
        <students-with-skills :organization="organization" :client="client"></students-with-skills>
      </b-tab>
      <b-tab
        v-if="!!fcqCoachTab"
        :title="fcqCoachTab.name"
        lazy
      >
        <custom-tab-fcq-coach
          :organization="organization"
          :client="client"
          :client-tab="fcqCoachTab"
        ></custom-tab-fcq-coach>
      </b-tab>
      <b-tab
        v-if="isJdm"
        :title="trans('registrations')"
        title-link-class="text-branded"
        lazy
      >
        <jdm-filled-forms :organization="organization" :client="client" :jdm="jdm"></jdm-filled-forms>
      </b-tab>
      <b-tab
        v-for="clientTab in visibleClientTabs"
        :key="`client-tab-${clientTab.id}`"
        :title="!!clientTab.type ? trans(clientTab.type) : clientTab.name"
        title-link-class="text-branded"
        lazy
      >
        <client-tab v-if="!clientTab.is_default" :organization="organization" :client="client" :client-tab="clientTab"></client-tab>
        <filled-forms v-if="clientTab.is_default" :organization="organization" :client="client" :client-tab="defaultFormsClientTab"></filled-forms>
      </b-tab>
      <b-tab
        v-if="showFilledFormsTab"
        :title="trans('forms')"
        title-link-class="text-branded"
        lazy
      >
        <filled-forms :organization="organization" :client="client" :client-tab="defaultFormsClientTab"></filled-forms>
      </b-tab>
      <b-tab
        v-if="showBookingsTab"
        :title="trans('bookings')"
        title-link-class="text-branded"
        lazy
      >
        <bookings :organization="organization" :client="client"></bookings>
      </b-tab>
      <b-tab
        v-if="showGiftCardsTab"
        :title="trans('gift_cards')"
        title-link-class="text-branded"
        lazy
      >
        <gift-cards :organization="organization" :client="client"></gift-cards>
      </b-tab>
      <b-tab
        v-if="showCouponsTab"
        :title="trans('coupons')"
        title-link-class="text-branded"
        lazy
      >
        <coupons :organization="organization" :client="client"></coupons>
      </b-tab>
      <b-tab
        v-if="showDiscountsTab"
        :title="trans('discounts')"
        title-link-class="text-branded"
        lazy
      >
        <discounts :organization="organization" :client="client"></discounts>
      </b-tab>
      <b-tab
        v-if="showInvoicesTab"
        :title="trans('invoices')"
        title-link-class="text-branded"
        lazy
      >
        <invoices :organization="organization" :client="client"></invoices>
      </b-tab>
      <b-tab
        v-if="showMembershipsTab"
        :title="trans('memberships')"
        title-link-class="text-branded"
        lazy
      >
        <memberships :organization="organization" :client="client"></memberships>
      </b-tab>
      <b-tab
        v-if="showDocumentsTab"
        :title="trans('documents')"
        title-link-class="text-branded"
        lazy
      >
        <documents :organization="organization" :client="client"></documents>
      </b-tab>
      <b-tab
        v-if="showTicketsTab"
        :title="trans('tickets')"
        title-link-class="text-branded"
        lazy
      >
        <tickets :organization="organization" :client="client"></tickets>
      </b-tab>
    </b-tabs>
  </div>
</template>
<style>
@media screen and (max-width: 575px) {
  .nav-pills-body {
    display: none;
  }
  .mobile-navigation-select {
    display: block !important;
  }
}
</style>
<script>
  import Connect from './Connect'
  import Information from './Information'
  import Coupons from './Coupons'
  import Discounts from './Discounts'
  import GiftCards from './GiftCards'
  import Bookings from './Bookings'
  import Classes from './Classes'
  import Teams from './Teams'
  import Invoices from './Invoices'
  import Memberships from './Memberships'
  import FilledForms from './FilledForms'
  import Documents from './Documents'
  import JdmFilledForms from './JdmFilledForms'
  import ClientTab from './ClientTab'
  import CustomTabFcqCoach from './CustomTabFcqCoach'
  import Tickets from './Tickets'
  import StudentsWithSkills from './StudentsWithSkills'

  export default {
    props: {
      organization: Object,
      client: Object,
      clientTabs: Array,
    },
    components: {
      Connect,
      Information,
      Coupons,
      Discounts,
      GiftCards,
      Bookings,
      Classes,
      Teams,
      Invoices,
      Memberships,
      FilledForms,
      Documents,
      JdmFilledForms,
      ClientTab,
      CustomTabFcqCoach,
      Tickets,
      StudentsWithSkills,
    },
    data() {
      return {
        trans: trans,
        is_iframed: _.isIframed(),
        tab: 0,
        jdm: null,
        links: [],
        selectedLink: null,
      }
    },
    computed: {
      isJdm() {
        return this.organization.id == 480 && (this.client?.isJdmAllowed || false)
      },
      showClassesTab() {
        return !this.isJdm && this.client.class_event_count > 0
      },
      showTeamsTab() {
        return !this.isJdm && this.client.team_count > 0
      },
      showStudentsWithSkillsTab() {
        return !this.isJdm && this.client.has_students_with_skills
      },
      fcqCoachTab() {
        return this.client.fcq_coach_tab
      },
      visibleClientTabs() {
        return _.reduce(this.clientTabs, (tabs, tab) => {
          let clientTabAccess = _.find(this.client.client_tab_accesses, {id: tab.id})
          if (!!clientTabAccess || tab.is_default || !tab.hide_tab_unless_approved) tabs.push(tab)
          return tabs
        }, [])
      },
      defaultFormsClientTab() {
        return _.find(this.clientTabs, {type: 'forms'})
      },
      showFilledFormsTab() {
        return !this.isJdm && this.client.filled_form_count > 0 && !this.defaultFormsClientTab
      },
      showBookingsTab() {
        return !this.isJdm && this.client.booking_count > 0
      },
      showGiftCardsTab() {
        return !this.isJdm && (this.client.gift_card_count > 0 || this.client.gift_card_log_count > 0)
      },
      showCouponsTab() {
        return !this.isJdm && this.client.coupon_count > 0
      },
      showDiscountsTab() {
        return !this.isJdm && this.client.discount_count > 0
      },
      showInvoicesTab() {
        return !this.isJdm
      },
      showMembershipsTab() {
        return !this.isJdm
      },
      showDocumentsTab() {
        return !this.isJdm && (this.client.rl24_slip_count || 0) > 0
      },
      showTicketsTab() {
        return !this.isJdm && this.client.has_upcoming_tickets
      }
    },
    methods: {
      onJdm(jdm) {
        this.jdm = jdm
      },
      mobileNavChange(value) {
        this.links.forEach((link, index) => {
          if (link === value) {
            this.tab = index
          }
        })
      }
    },
    mounted() {
      window.myAccount = this
      this.$nextTick(() => {
        let links = []
        document.querySelectorAll('.nav-pills-body li a').forEach(function(link) {
          links.push(link.textContent)
        });
        if (links.length > 0) {
          this.selectedLink = links[0]
        }
        this.links = links
      });
    },
  }
</script>